var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 422,
    viewBox: "0 0 422 422",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_1165)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.608643,
    width: 421.06,
    height: 421.06,
    rx: 210.53,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-81.9623 0.608643C-83.7448 0.608643 -85.1898 2.05368 -85.1898 3.83622V434.435C-85.1898 436.218 -83.7448 437.663 -81.9623 437.663H482.462C484.245 437.663 485.69 436.218 485.69 434.435V3.83621C485.69 2.05367 484.245 0.608643 482.462 0.608643H-81.9623ZM141.41 135.866H112.296L93.5196 291.984H116.937L119.68 258.018H132.76L135.503 291.984H160.186L141.41 135.866ZM121.368 237.343L123.899 205.275L125.798 178.271H126.431L128.33 205.275L131.072 237.343H121.368ZM186.814 291.984H211.92V233.123H219.726C237.658 233.123 248.629 222.575 248.629 203.799V165.402C248.629 146.415 237.658 135.866 219.726 135.866H186.814V291.984ZM217.616 214.347H212.131V154.643H217.616C221.835 154.643 223.523 158.44 223.523 165.402V203.799C223.523 210.55 221.835 214.347 217.616 214.347ZM277.548 135.866V291.984H326.493V271.309H302.653V223.419H323.961V202.744H302.653V156.541H326.493V135.866H277.548Z",
    fill: "#0054FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_1165"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.608643,
    width: 421.06,
    height: 421.06,
    rx: 210.53,
    fill: "white"
  })))));
};
export default SvgLogoNoText;